import styled from '@emotion/styled';
import { Flex } from '@qga/roo-ui/components';
import { themeGet } from 'styled-system';

export const LogOutButton = styled(Flex)`
  padding-bottom: ${themeGet('space.4')};
  border-bottom: 2px solid ${themeGet('colors.greys.porcelain')};
`;
